import styled from "styled-components";
import HouseAdvertisementSession from "../../components/house_advertisement_session/HouseAdvertisementSession";
import Infos from "../../components/infos/Infos";
import MainBanner from "../../components/main_banner/MainBanner";
import MostSearched from "../../components/most_searched/MostSearched";
import Suggestions from "../../components/suggestions/Suggestions";
import WrapperHome from "./Styles-Home";
import SlideShowBanners from "../../components/slide_show_type_d/SlideShowTypeD";
import Banner2 from "../../imgs/BANNER 02.jpg";
import Banner1 from "../../imgs/BANNER 01.jpg";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from './../../context/AuthContext';


const Home = () => {
  const { userData } = useContext(AuthContext);
  const [filters, setFilters] = useState(null);

  useEffect(() => {
    if (userData && userData.myLocation?.cep !== "") {
      setFilters([{ filterName: "city", value: userData.myLocation.city }]);
    } else {
      setFilters([]);
    }
  }, [userData]);

  return (
    <WrapperHome>
      <MainBanner />
      {filters !== null &&
          <>
            {/* <HouseAdvertisementSession
            title="Anúncios Lançamentos:"
            filters={[{ filterName: "planId", value: "ziK3BUUd5mPCBC4NW5n9" }]}
          /> */}
          <HouseAdvertisementSession
            title="Anúncios Turbinados:"
            filters={[{ filterName: "highlight", value: true }]}
          />
        </>
      }
      <MostSearched />
      <Infos />
      {filters !== null &&
        <HouseAdvertisementSession 
          title="Sugestões para você" 
          filters={filters} 
        />
      }
      <Suggestions />
      <SlideShowBanners
        items={[
          { banner: "https://firebasestorage.googleapis.com/v0/b/compreimoveis-d0aaa.firebasestorage.app/o/banners%2Ffirst-banner-session-2.png?alt=media&token=0df5d727-0760-492e-87d7-5a87f4d1a1cd", to: "/anunciar" },
          { banner: "https://firebasestorage.googleapis.com/v0/b/compreimoveis-d0aaa.firebasestorage.app/o/banners%2Fsecond-banner-session-2.png?alt=media&token=89adac18-e7ca-495a-8d8e-6cdce4b562e2", to: "/buscador" },
        ]}
        visibleItems={1}
      />
    </WrapperHome>
  );
};

export default Home;
